<div class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center">
  <!-- Modal con dimensioni standard più piccole, ma grandi su 2xl -->
  <div class="bg-white/95 w-[600px] max-w-md 2xl:max-w-none mx-4 py-3 pl-4 pr-6 2xl:py-4 2xl:pl-5 2xl:pr-8 max-h-[80vh] 2xl:max-h-[85vh] rounded-md shadow-lg space-y-3 2xl:space-y-4 overflow-y-auto 2xl:overflow-y-hidden relative text-xs 2xl:text-sm">
  
    <!-- Header -->
    <div class="mb-4 2xl:mb-6">
      <h1 class="text-base 2xl:text-lg mb-1.5 2xl:mb-2 mt-0.5 2xl:mt-1 text-dimot-1">Modifica il tuo profilo</h1>
      <div class="text-gray-600 text-[0.82rem] 2xl:text-xs leading-snug">
        <span class="inline">Non condivideremo mai i tuoi dati. Consulta la nostra</span>
        <h4 class="inline font-bold ml-1">Informativa sulla privacy.</h4>
      </div>
    </div>
  
    <!-- Full name section -->
    <div class="flex flex-col gap-0.5 2xl:gap-1">
      <span class="text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Nome completo</span>
      <div class="space-y-2 2xl:space-y-3">
        <input 
          type="text"
          class="w-full pl-2 p-1 2xl:p-1.5 border rounded-md focus:ring-1 focus:ring-gray-300 focus:border-gray-300 text-xs 2xl:text-sm" 
          placeholder="Inserisci il tuo nome"
        >
        <div>
          <label class="block text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Email</label>
          <input 
            type="email"
            value="giovanni.izzo@leo.com"
            readonly
            class="text-gray-400 w-full p-1 2xl:p-1.5 pl-2 border rounded-md cursor-not-allowed text-xs 2xl:text-sm"
          >
        </div>
      </div>
    </div>
  
    <!-- Country section -->
    <div class="flex flex-col gap-0.5 2xl:gap-1">
      <span class="text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Paese</span> 
      <div class="space-y-2 2xl:space-y-3">
        <select class="w-full p-1 2xl:p-1.5 pl-2 border rounded-md text-xs 2xl:text-sm focus:ring-1 focus:ring-gray-300 focus:border-gray-300">
          <option selected value="IT">Italia</option>
        </select>
  
        <div>
          <div class="flex flex-col gap-0.5 2xl:gap-1">
            <span class="text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Accesso alle regioni</span>
            <div class="relative w-full">
              <button
                type="button"
                (click)="toggleDropdown()"
                class="w-full text-left p-1 2xl:p-1.5 pl-2 border rounded-md text-xs 2xl:text-sm focus:ring-1 focus:ring-gray-300 bg-white" 
              >
                {{ selectedRegions.length === allRegions.length ? 'Tutte le regioni' : selectedRegions.length ? selectedRegions.join(', ') : 'Seleziona regioni' }}
              </button>
  
              <!-- Regions dropdown -->
              <div *ngIf="dropdownOpen" class="absolute z-10 mt-0.5 2xl:mt-1 w-full bg-white border rounded-md shadow-md h-[100px] 2xl:h-[120px] overflow-y-auto text-xs 2xl:text-sm">
                <label class="flex items-center px-2 py-0.5 2xl:py-1 hover:bg-gray-100 cursor-pointer">
                  <input
                    type="checkbox"
                    class="form-checkbox h-3 w-3 mr-2 focus:ring-0 focus:ring-offset-0" 
                    [checked]="areAllSelected()"
                    (change)="toggleAll($event)"
                  >
                  Tutte le regioni
                </label>
  
                <label *ngFor="let region of allRegions" class="flex items-center px-2 py-0.5 2xl:py-1 hover:bg-gray-100 cursor-pointer">
                  <input
                    type="checkbox"
                    class="form-checkbox h-3 w-3 mr-2 focus:ring-0 focus:ring-offset-0" 
                    [checked]="selectedRegions.includes(region)"
                    (change)="toggleRegion(region, $event)"
                  >
                  {{ region }}
                </label>
              </div>
            </div>
          </div>
  
          <!-- Password -->
          <div class="flex flex-col gap-0.5 2xl:gap-1 mt-1.5 2xl:mt-2">
            <label class="block text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Password</label>
            <input 
              type="password"
              value=""
              class="w-full p-1 2xl:p-1.5 pl-2 border rounded-md text-xs 2xl:text-sm focus:ring-1 focus:ring-gray-300 focus:border-gray-300" 
            >
          </div>
        </div>
      </div>
    </div>
  
    <!-- Buttons -->
    <div class="relative pt-1.5 2xl:pt-2 mt-4 2xl:mt-6">
      <button type="button" class="border-1 border-dimot-1 bg-dimot-1 text-white hover:bg-white hover:text-dimot-1 w-32 h-8 rounded-md flex flex-row justify-center gap-2 items-center group cursor-pointer relative">
        <span class="text-[0.65rem]">Salva Modifiche</span>
        <svg
          class="text-white group-hover:text-[#141F58]"
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5415 17.5V13.5292C13.5413 13.355 13.5067 13.1826 13.4398 13.0219C13.373 12.8611 13.275 12.7151 13.1517 12.5922C13.0283 12.4693 12.8819 12.3719 12.7209 12.3056C12.5598 12.2393 12.3873 12.2054 12.2132 12.2058H7.7865C7.61236 12.2054 7.43984 12.2393 7.27881 12.3056C7.11778 12.3719 6.97139 12.4693 6.84802 12.5922C6.72465 12.7151 6.62672 12.8611 6.55983 13.0219C6.49293 13.1826 6.45839 13.355 6.45817 13.5292V17.5M13.5415 2.73751V4.70584C13.5413 4.87998 13.5067 5.05237 13.4398 5.21316C13.373 5.37394 13.275 5.51996 13.1517 5.64286C13.0283 5.76577 12.8819 5.86315 12.7209 5.92943C12.5598 5.99572 12.3873 6.02961 12.2132 6.02918H7.7865C7.61236 6.02961 7.43984 5.99572 7.27881 5.92943C7.11778 5.86315 6.97139 5.76577 6.84802 5.64286C6.72465 5.51996 6.62672 5.37394 6.55983 5.21316C6.49293 5.05237 6.45839 4.87998 6.45817 4.70584V2.50001M13.5415 2.73751C13.1959 2.58099 12.8209 2.50003 12.4415 2.50001H6.45817M13.5415 2.73751C13.8282 2.86751 14.0923 3.04918 14.3198 3.27501L16.3048 5.25418C16.5513 5.49944 16.7469 5.79096 16.8805 6.112C17.0141 6.43304 17.0829 6.77729 17.0832 7.12501V14.8517C17.083 15.2 17.0141 15.5449 16.8804 15.8666C16.7468 16.1883 16.551 16.4805 16.3044 16.7265C16.0577 16.9725 15.7649 17.1674 15.4429 17.3001C15.1208 17.4329 14.7757 17.5008 14.4273 17.5H5.57317C5.22482 17.5009 4.87971 17.4331 4.55759 17.3004C4.23547 17.1678 3.94266 16.973 3.69591 16.7271C3.44916 16.4812 3.25332 16.1891 3.11958 15.8674C2.98584 15.5457 2.91683 15.2009 2.9165 14.8525V5.14668C2.91694 4.79839 2.98603 4.45361 3.11982 4.13205C3.2536 3.81048 3.44947 3.51845 3.69621 3.27264C3.94294 3.02683 4.23572 2.83207 4.55778 2.69949C4.87985 2.56692 5.22489 2.49913 5.57317 2.50001H6.45817"
            stroke="currentColor"
            stroke-width="0.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  
    <!-- Close button -->
    <button (click)="close()"
      class="cursor-pointer absolute top-1.5 2xl:top-2 right-1.5 2xl:right-2 text-gray-500 hover:text-black transition text-xs 2xl:text-sm focus:ring-0" 
      aria-label="Chiudi"
    >
      ✕
    </button>
  </div>
</div>